// extracted by mini-css-extract-plugin
module.exports = {"root":"root-23DblPj_Q6","centered":"centered-10HAz_pGqf"};